module.exports = __webpack_public_path__ + "ecb6e9b09bf07c66b4140a12e11246bc.png";